import { CustomModalCell } from '../../components/custom-modal-cell';

export const LEGAL_FORM_NAME = 'legal-form';

export const REQUIRED_FIELDS = [
	'name',
	'inn',
	'ogrn',
	'address',
	'contact.last_name',
	'contact.first_name',
	'contact.phone',
];

export const FIELDS_FOR_VALIDATE = [
	'name',
	'inn',
	'ogrn',
	'address',
	'contact.last_name',
	'contact.first_name',
	'contact.middle_name',
	'contact.email',
	'contact.phone',
	'contact.extension',
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const LEGAL_TABLE_COLUMNS_NAMES = [{ id: 'title' }, { id: 'value', customComponent: CustomModalCell }];

export const LEGAL_TABLE_ROWS_NAMES = {
	inn: 'ИНН',
	ogrn: 'ОГРН',
	address: 'Юридический адрес',
	author: 'Автор',
	contact: 'Контакты',
};
